<template>
    <div>
        <h4>Upload</h4>
        <div class="form-group row" v-show="!stackFull && !uploaded">
            <label class="col-sm-4 col-form-label">{{$trans('shop.labels.article.upload')}}</label>
            <div class="col-sm-8">
                <span v-show="loading">
                    <i class="fa fa-spinner fa-spin"></i>
                </span>
                <div class="custom-file" v-show="!loading">
                    <input type="file" class="custom-file-input" name="files" ref="filesInput" multiple
                           v-on:change="handleFilesSelected()"accept="application/pdf, application/zip"/>
                    <label class="custom-file-label" v-on:click="addFiles()">{{$trans('shop.labels.article.chooseFile')}}</label>
                </div>
            </div>
        </div>
        <div class="container" v-if="uploaded">
            <div class="alert alert-success">{{$trans('shop.messages.cart.uploadSuccess')}}</div>
        </div>
        <input type="hidden" v-for="(file, key) in files" v-bind:name="'file[' + key +']'" v-bind:value="file.id"/>
    </div>
</template>

<script>
    export default {
        props: [],
        data() {
            return {
                errors: [],
                files: [],
                temps: [],
                maxFiles: 1,
                loading: false,
                type: 1,
                uploaded: false
            }
        },
        computed: {
            stackFull: function () {
                return this.files.length >= this.maxFiles;
            },
        },
        mounted() {
        },
        methods: {
            addFiles() {
                this.$refs.filesInput.click();
            },
            handleFilesSelected() {
                this.resetErrors();
                let uploadedFiles = this.$refs.filesInput.files;
                for (let i = 0; i < uploadedFiles.length; i++) {
                    if (this.maxFiles <= this.temps.length + this.files.length) {
                        this.errors.push("Too many files selected.");
                        continue;
                    }
                    this.temps.push(uploadedFiles[i]);
                }
                this.submitFiles();
            },
            submitFiles() {
                let formData = new FormData();
                for (let i = 0; i < this.temps.length; i++) {
                    let file = this.temps[i];
                    formData.append('files[' + i + ']', file);
                }
                let title = document.getElementsByClassName('article-title')[0].innerText;
                title = title.split(',').slice(0,1).join('_').replace(/\s+/g, '_').toLowerCase();
                title += '_' + Math.random().toString(36).replace('0.', '')
                formData.append('title', title);
                formData.append('type', this.type);
                let _that = this;
                this.$refs.filesInput.value = "";
                this.loading = true;
                axios.post(
                    route('shop.upload'),
                    formData,
                    {headers: {'Content-Type': 'multipart/form-data'}}
                )
                    .then(function (response) {
                        _that.temps = [];
                        _that.loading = false;
                        _that.uploaded = true;
                        let addToCartButton = document.getElementsByClassName('btn-add-to-cart')[0];
                        document.getElementById('uploaded_file_name').value = response.data.name;
                        addToCartButton.removeAttribute('disabled');
                    })
                    .catch(function (error) {
                        console.log(error);
                        _that.loading = false;
                        _that.errors[0] = [error.response.data.message];
                        _that.temps = [];
                    });
            },
            resetErrors: function () {
                this.errors = [];
            },
            hasError: function () {
                return this.errors.length;
            },
            firstError: function () {
                return this.errors[0];
            },
        }
    }
</script>
